import { useEffect } from 'react';
import HomePopupStore from 'store/HomePopup';
import { EHomePopupKey, HOME_POPUP_PRIORITY } from 'constants/homePopups';
import { getViewMode } from 'utils/sessionStorage';
import { MODE } from 'constants/common';

const sortedPriority = [...HOME_POPUP_PRIORITY].sort((a, b) => a.priority - b.priority);

export default function useHomePopup(key: EHomePopupKey, isEligible: boolean) {
    const [get, set] = HomePopupStore.useStore();

    useEffect(() => {
        const current = HomePopupStore.get('eligibleMap') || {};
        HomePopupStore.set('eligibleMap', { ...current, [key]: isEligible });
    }, [key, isEligible]);

    useEffect(() => {
        return () => {
            const current = HomePopupStore.get('eligibleMap') || {};
            HomePopupStore.set('eligibleMap', { ...current, [key]: false });
        };
    }, [key]);

    const eligibleMap = get('eligibleMap') || {};
    const dismissedMap = get('dismissedMap') || {};

    const activeKey = sortedPriority.find(
        (p) => eligibleMap[p.key] && !dismissedMap[p.key],
    )?.key;

    const isOpsPreview = getViewMode() === MODE.OPS_PREVIEW;
    const shouldShow = !isOpsPreview && activeKey === key;

    const dismiss = () => {
        const current = HomePopupStore.get('dismissedMap') || {};
        HomePopupStore.set('dismissedMap', { ...current, [key]: true });
    };

    return { shouldShow, dismiss };
}
